import * as React from 'react';
import * as classnames from 'classnames/bind';
import {observer} from 'mobx-react';
import {CommonUtils} from '@mintdata/mint-kit/impl/util/CommonUtils';

const styles = require('./ProgressBar.less');
const cx = classnames.bind(styles);

export interface IProgressBarProps
{
    className?:string;
    progressTrackClassName?:string;
    value?:number; // [0...1], omitting = indeterminate
    animate?:boolean,
    stripes?:boolean
}

@observer
export class ProgressBar extends React.Component<IProgressBarProps, any>
{
    public render():JSX.Element
    {
        const {
            className,
            progressTrackClassName,
            value,
            animate = true,
            stripes = true
        } = this.props;

        const width = value == null ? null : `${100 * CommonUtils.clamp(value, 0, 1)}%`;

        return (
            <div className={cx('base', {animate, stripes}, className)}>
                <div className={cx('progressTrack', progressTrackClassName)} style={{width}} />
            </div>
        );
    }
}
